// monitoring/* page translations
const monitoring = {
  home: {
    title: 'Enterprise Monitoring',
    loading: 'Loading data...',
    noFactories: 'No factories registered',
    registerFactoryHint: 'Please register a factory in the System Management menu first',
    status: {
      total: 'Total Machines',
      running: 'Running',
      idle: 'Idle',
      stopped: 'Stopped',
    },
  },
  enterprise: {
    v2: {
      targetModal: {
        title: 'Daily Production Target by Factory',
        hint: 'Enter each factory daily target (shots). It applies every day until changed, and the company target is their sum. Leave empty to clear a factory target.',
        factory: 'Factory',
        today: 'Today',
        target: 'Daily target',
        placeholder: 'Not set',
        unit: 'ea',
        total: 'Company target (sum)',
        saving: 'Saving...',
        invalid: 'Enter a whole number of 1 or more',
        saveFailed: 'Could not save. Please try again',
        notDeployed: 'Per-factory targets are not deployed on the server yet',
        forbidden: 'You do not have factory edit permission',
        noPermission: 'Factory edit (factory.update) permission is required to change targets',
      },
      breadcrumbRoot: 'Enterprise',
      pageLabel: 'Integrated Dashboard',
      refresh: 'Refresh',
      retry: 'Retry',
      loading: 'Loading...',
      noData: 'No data',
      loadFailed: 'Failed to load dashboard data',
      unitEa: 'ea',
      unitMachine: '',
      estimated: 'est.',
      level: {
        good: 'Normal',
        warn: 'Warning',
        bad: 'Critical',
      },
      kpi: {
        oee: 'Overall OEE',
        availability: 'Availability',
        performance: 'Performance',
        quality: 'Good rate',
        defectRate: 'Defect rate',
        utilization: 'Machine utilization',
        production: 'Daily production',
        energy: 'Energy',
        oeeSub: 'Target {target}% · {diff}%p',
        baseline: 'Baseline {v}',
        inRange: 'Within range',
        defectSub: '{n} defects · baseline ≤{v}',
        defectEstimated: '100 − good rate (est.)',
        utilizationSub: '{r} / {n} running',
        productionSub: '{p}% of target',
        noTarget: 'No target set',
        energySub: '{p}% vs yesterday',
        today: 'Today',
      },
      chart: {
        productionTitle: 'Production · Utilization Trend',
        oeeTitle: 'OEE Components Trend',
        days: '({n} days)',
        production: 'Production (EA)',
        rate: 'Utilization (%)',
        oee: 'OEE',
        availability: 'Availability',
        performance: 'Performance',
        quality: 'Quality',
      },
      factory: {
        title: 'Factories',
        activeAlarms: '{n} open alarms',
        rate: 'Utilization',
        production: 'Production',
        equipment: 'Machines',
        running: 'Running',
        stopped: 'Stopped',
        collect: {
          ok: 'Collecting',
          partial: 'Partly stopped',
          lost: 'Collection lost',
          none: 'No machines',
        },
      },
      alarm: {
        title: 'Enterprise',
        all: 'View all',
        critical: 'Critical',
        warning: 'Warning',
        info: 'Info',
        empty: 'No recent alarms',
      },
      target: {
        factoryGoal: '{a} / {g}',
        factoryNoTarget: 'No target',
        companyOnlyNote: 'Only a company-wide target is set — set per-factory targets with the gear button',
        title: 'Production vs Target (today)',
        ratio: 'Achievement',
        goal: 'Target',
        actual: 'Actual',
        remaining: 'Remaining',
        eta: 'Estimated completion',
        hm: '{h}h {m}m',
        m: '{m}m',
        done: 'Achieved',
        factoryNote: 'Factory bars: factory production vs company target (no per-factory target)',
      },
    },
    reports: {
      daily: 'Daily Report',
      weekly: 'Weekly Report',
      monthly: 'Monthly Report',
    },
    oee: {
      targetSetting: 'Target Production Setting',
    },
  },
  factory: {
    selectFactory: 'Select Factory',
    loadingData: 'Loading data...',
    noFactories: 'No factories registered',
    registerFactoryHint: 'Please register a factory in the System Management menu first',
    loadFailed: 'Failed to load data.',
    factoryListLoadFailed: 'Failed to load factory list.',
    retry: 'Retry',
    refresh: 'Refresh',
    breadcrumbRoot: 'Enterprise',
    overview: 'OVERVIEW',
    kpi: {
      activeRatio: 'Active',
      totalMachines: 'Machines',
      running: 'Running',
      idle: 'Idle',
      stopped: 'Stopped',
      pendingAlarms: 'Open Alarms',
      oee: 'OEE',
      dailyProduction: 'Daily Production',
      machineUnit: '',
      caseUnit: '',
    },
    environment: {
      title: 'Env',
      temperature: 'Temp',
      tempUnit: '°C',
      humidity: 'Humidity',
      energy: 'Energy',
      noise: 'Noise',
    },
    line: {
      title: 'Line Status',
      production: 'Production',
      alarms: 'Alarms',
      caseUnit: '',
      running: 'Run',
      idle: 'Idle',
      stopped: 'Stop',
      empty: 'No line information',
    },
    machine: {
      title: 'Machine Status',
      statusFilter: 'Status',
      lineFilter: 'Line',
      running: 'Running',
      idle: 'Idle',
      stopped: 'Stopped',
      moldNumber: 'Mold No.',
      shotCount: 'Shot Count',
      cav: 'CAV', // 캐비티 수 — 현장 약어 그대로
      ct: 'C/T', // 사이클 타임 — 현장 약어 그대로
      alarmsTitle: '{n} active alarms',
      loading: 'Loading machines...',
      empty: 'No machines to display',
    },
    alarm: {
      title: 'Live Alarms',
      all: 'All',
      critical: 'Critical',
      warning: 'Warning',
      noActiveAlarms: 'No active alarms.',
    },
  },
  realtimeShot: {
    v2: {
      breadcrumbRoot: 'Enterprise',
      allFactories: 'All factories',
      refresh: 'Refresh',
      factory: 'Factory',
      line: 'Line',
      all: 'All',
      deviationOnly: 'Deviations only',
      summary: '{n} machines · {d} deviating',
      deviationTip: 'Deviation (estimated): value changed ±5% or more vs the previous shot — computed on screen, no limit API',
      prevShot: 'Previous shot',
      noDeviation: 'No deviating machines',
      colEquipment: 'Machine',
      colUpdate: 'Updated',
    },
    title: 'Realtime Shot Status',
    subtitle: 'Realtime shot status by machine',
    update: 'Updated',
    loading: 'Loading data...',
    loadFailed: 'Failed to load data.',
    retry: 'Retry',
    noData: 'No data available.',
    options: {
      highlight: 'Highlight Changes',
      delta: 'Show Delta',
      sortByUpdate: 'Sort by Update',
    },
    columns: {
      equipmentName: 'Machine',
      craftId: 'Product',
      shotCount: 'Shot Count',
      updateDateTime: 'Update Time',
      cycleTime: 'Cycle Time',
      tmInjSpeed1: 'Inj Speed',
      tmInjPress1: 'Inj Pressure',
      tmInjPosi1: 'Inj Position',
      tmHoldSpeed1: 'Hold Speed',
      tmHoldPress1: 'Hold Pressure',
      tmChargePress1: 'Charge Pressure',
      tmChargePosi1: 'Charge Position',
      turnPosi: 'Inj End Position',
      cushion: 'Cushion',
      tmTemp1Current: 'Temp 1',
      tmTemp2Current: 'Temp 2',
      tmTemp3Current: 'Temp 3',
      tmTemp4Current: 'Temp 4',
      tmTemp5Current: 'Temp 5',
    },
  },
  alarmAnalysis: {
    title: 'Alarm Detail Analysis',
    machinePrefix: 'Machine: {name}',
    alarmIdPrefix: 'Alarm ID: {id}',
    loading: 'Loading alarm data...',
    loadFailed: 'Failed to load alarm data.',
    loadFailedTitle: 'Data Load Failed',
    retry: 'Retry',
    info: {
      title: 'Alarm Information',
      alarmId: 'Alarm ID',
      machine: 'Machine',
      occurredAt: 'Occurred At',
      duration: 'Duration',
      severity: 'Severity',
      status: 'Status',
    },
    message: {
      title: 'Alarm Message',
      description: 'An API to display alarm details is required.',
      note: 'This page is set up to receive alarm ID and machine info from URL parameters.',
    },
    cause: {
      title: 'Cause Analysis',
      placeholder: 'Alarm cause analysis information will be displayed here.',
    },
    action: {
      title: 'Recommended Actions',
      placeholder: 'Recommended actions will be displayed here.',
    },
    apiNotice: {
      label: 'API Integration Required:',
      description: 'A backend API endpoint is required to display alarm details.',
      endpoint: 'Expected endpoint:',
    },
  },
  machine: {
    breadcrumbRoot: 'Enterprise',
    breadcrumbMonitoring: 'Monitoring',
    selectMonitoringPage: 'Select monitoring page',
    refresh: 'Refresh',
    selectFactory: 'Select Factory',
    factoryPage: 'Open factory overview',
    factoryMachineCount: '{n} machines',
    selectMachine: 'Select Machine',
    loading: 'Loading...',
    loadingData: 'Loading data...',
    noEquipment: 'No equipment registered',
    registerEquipmentHint: 'Please register equipment in the System Management menu first',
    tabs: {
      overviewNew: 'Overview (New)',
      process: 'Process',
      dashboard: 'Dashboard',
      quality: 'Quality · Production',
      dataLog: 'Data · Logs',
    },
    tabPlaceholder: '{tab} content area (to be added)',
    chartLabel: {
      shotNumber: 'Shot No.',
      tempC: 'Temp(°C)',
      pressureMpa: 'Pressure(MPa)',
      powerKw: 'Power(kW)',
      speedMms: 'Speed(mm/s)',
      positionMm: 'Position(mm)',
    },
    legendName: {
      injectionPressure: 'Inj Pressure',
      holding: 'Holding',
      meteringPressure: 'Metering Pressure',
      backPressure: 'Back Pressure',
      holdingPressure: 'Hold Pressure',
      injectionPressure2: 'Inj Pressure',
      cycleTime: 'Cycle Time',
      injectionTime: 'Inj Time',
      holdingTime: 'Hold Time',
      meteringTime: 'Metering Time',
      coolingTime: 'Cooling Time',
      pressureKw: 'Power(kW)',
      speed: 'Speed',
      position: 'Position',
      occurrence: 'Occurrences',
      cumulativeRatio: 'Cumulative Ratio (%)',
      alarmCount: 'Alarm Count',
      ucl: 'UCL',
      cl: 'CL',
      lcl: 'LCL',
      measured: 'Measured',
      rangeValue: 'Range',
      upper: 'Upper',
      lower: 'Lower',
      motorStatus: 'Motor Status',
    },
    common: {
      noData: 'No data',
      loading: 'Loading...',
      dataLoadFailed: 'Failed to load data.',
      productionWidgetWip: 'Production widget in progress',
      configError: 'Configuration error',
      widgetContent: 'Widget content',
      occurredPrefix: 'Occurred: ',
      occurring: 'Active',
      resolved: 'Resolved',
      alarmHistoryEmpty: 'No alarm history',
    },
    widget: {
      titleSuffix: {
        temperature: 'Temperature(°C)',
        pressure: 'Pressure(MPa)',
        energy: 'Energy(kW)',
      },
      modal: {
        title: 'Add Dashboard Widget',
        size1x1: '1×1 (Default)',
        size2x1: '2×1 (Wide)',
        size1x2: '1×2 (Tall)',
        size2x2: '2×2 (Large)',
        back: 'Back',
      },
      dashboardNew: {
        myDashboard: 'My Dashboard',
        subtitle: '{n} widgets',
        autoRefresh: 'Auto refresh {v}',
        addEdit: 'Add widgets · Edit',
        editMode: 'Edit mode',
        editHint: 'Drag widgets to place · click the size badge to resize · X to remove',
        resetLayout: 'Reset layout',
        resetConfirm: 'Remove all placed widgets?',
        doneEdit: 'Done',
        addWidget: 'Add widget',
        remove: 'Remove',
        sizeBadgeHint: 'Click to switch to the next size that fits',
        searchPlaceholder: 'Search widgets (temperature, pressure, alarm…)',
        cat: { all: 'All', process: 'Process', equipment: 'Equipment', quality: 'Quality', alarm: 'Alarm', user: 'Custom' },
        catHint: 'Click a chip to show that category only',
        note: { process: 'Process', equipment: 'Equipment', quality: 'Quality', alarm: 'Alarm', user: 'Custom' },
        placed: 'Placed',
        add: 'Add',
        placedCount: 'Placed widgets {n} / {total}',
        close: 'Close',
        noResults: 'No widgets found',
        sizeTitle: 'Select widget size',
        sizeHint: 'Choose the number of grid cells. You can change it later with the size badge.',
        sizeDesc: { '1x1': '1–2 key figures', '2x1': 'Tables and trend charts (recommended)', '1x2': 'Lists and history', '2x2': 'Combined charts · details' },
        addWithSize: 'Add as {size}',
        noFit: 'No empty space for this size',
      },
      types: {
        temperature: { name: 'Temperature', desc: 'Zone temperature status and trends' },
        pressure: { name: 'Pressure', desc: 'Injection/holding pressure monitoring' },
        energy: { name: 'Energy', desc: 'Power consumption and efficiency' },
        basicInfo: { name: 'Basic Info', desc: 'Product, shot count, cycle time, cavities' },
        alarmHistory: { name: 'Alarm History', desc: 'Recent alarm history' },
        injectionInfo: { name: 'Injection Info', desc: 'Injection settings and parameters' },
        custom: { name: 'Custom Module', desc: 'Add custom widget' },
        cycle: { name: 'Cycle', desc: 'Cycle time avg/min/max and recent shots' },
        spc: { name: 'SPC', desc: 'X-bar chart · UCL/LCL out-of-control detection' },
        quality: { name: 'Good/Defect', desc: "Today's good rate, good and defect counts" },
      },
      body: {
        loading: 'Loading...',
        loadFailed: 'Failed to load',
        noData: 'No data',
        warning: 'Warning',
        set: 'Set',
        latestShot: 'latest shot',
        avgPower: 'Avg of last {n} shots',
        power: 'Power',
        today: 'today',
        sampleNote: 'last {n} shots',
        efficiency: 'Efficiency',
        shot: 'shot',
        legendInjection: 'Injection',
        legendHolding: 'Holding',
        avg: 'Avg',
        min: 'Min',
        max: 'Max',
        cycleTime: 'Cycle time',
        measured: 'Measured',
        out: 'Out',
        spcNote: 'X-bar chart · {p}',
        goodRate: 'Good rate',
        good: 'Good',
        defect: 'Defect',
        defectRate: 'Defect rate',
      },
      builder: {
        title: 'Create Custom Module',
        widgetSize: 'Widget Size',
        widgetTitle: 'Widget Title',
        widgetTitlePlaceholder: 'Enter widget title',
        chartType: 'Chart Type',
        chartLine: 'Line Chart',
        chartBar: 'Bar Chart',
        chartArea: 'Area Chart',
        xAxis: 'X-Axis Data',
        yAxis: 'Y-Axis Data',
        xShotNumber: 'Shot Number',
        xTime: 'Time',
        yPressure: 'Pressure (MPa)',
        yTemperature: 'Temperature (℃)',
        ySpeed: 'Speed (mm/s)',
        yPosition: 'Position (mm)',
        preview: 'Preview',
        summary: 'Summary',
        summarySize: 'Size',
        summaryTitle: 'Title',
        summaryTitleEmpty: '(empty)',
        summaryChart: 'Chart Type',
        summaryX: 'X-Axis',
        summaryY: 'Y-Axis',
        cancel: 'Cancel',
        complete: 'Done',
      },
    },
    overview: {
      basicInfo: 'Basic Info',
      injection: 'Injection',
      holding: 'Holding',
      metering: 'Metering',
      mold: 'Mold',
      ejector: 'Ejector',
      heater: 'Heater Temp',
      noData: 'No data',
      labels: {
        productName: 'Product',
        shotCount: 'Shot Count',
        cycleTime: 'Cycle Time',
        cavityCount: 'Cavities',
        unitCount: 'shots',
        unitPiece: 'pcs',
        maxPressure: 'Max Inj Pressure',
        startPosition: 'Inj Start Position',
        switchPosition: 'Inj Switch Position',
        injectionTime: 'Inj Time',
        injectionSpeed: 'Inj Speed',
        suckbackTime: 'Suckback Time',
        suckbackSpeed: 'Suckback Speed',
        switchMode: 'Hold Switch Mode',
        switchInput: 'Hold Switch Input',
        pressure1: 'Hold Pressure 1',
        pressure2: 'Hold Pressure 2',
        time1: 'Hold Time 1',
        time2: 'Hold Time 2',
        meteringPosition: 'Metering Position',
        meteringSpeed: 'Metering Speed',
        meteringPressure: 'Metering Pressure',
        meteringTime: 'Metering Time',
        moldThickness: 'Mold Thickness',
        openPosition: 'Open Position',
        closePosition: 'Close Position',
        openTime: 'Open Time',
        closeTime: 'Close Time',
        moldTemp1: 'Mold Temp 1',
        moldTemp2: 'Mold Temp 2',
        forwardPosition: 'Forward Position',
        backwardPosition: 'Backward Position',
        forwardSpeed: 'Forward Speed',
        backwardSpeed: 'Backward Speed',
        zoneTemp: 'Zone {n} Temp',
        nozzleTemp: 'Nozzle Temp',
      },
    },
    spc: {
      measurementItem: 'Parameter',
      params: {
        cycleTime: 'Cycle Time',
        injectionPressure: 'Inj Pressure',
        injectionSpeed: 'Inj Speed',
        moldTemperature: 'Mold Temp',
        cushion: 'Cushion',
      },
      loading: 'Loading SPC data...',
      xbarChart: 'X̄ Chart (X-bar)',
      rChart: 'R Chart',
      stats: 'Statistics',
      processCapability: 'Process Capability',
      basicStats: 'Basic Statistics',
      defectRate: 'Defect Rate',
      sampleCount: 'Sample Count',
      mean: 'Mean',
      stdDev: 'Std Dev',
      min: 'Min',
      max: 'Max',
      range: 'Range',
      anomalyDetection: 'Anomaly Detection',
      anomalyTime: 'Time',
      anomalyValue: 'Value',
      anomalyType: 'Type',
      noAnomaly: 'No anomalies detected',
    },
    passFail: {
      back: 'Back',
    },
    inspectionPhotos: {
      subTabSpc: 'Process Control (SPC)',
      subTabJudge: 'Process Inspection',
      subTabProduction: 'Production',
      subTabPhotos: 'Vision Inspection',
      subTabFusion: 'Fusion Inspection',
      subTabSync: 'Shot Sync',
      comingSoon: 'Coming soon',
      period: 'Period',
      good: 'Good',
      none: 'Unjudged',
      warn: 'Caution',
      bad: 'Defect',
      upload: 'Upload Photos',
      uploadNotice: 'Uploaded photos are kept as a preview on this screen only (server storage not connected yet)',
      front: 'Front',
      topView: 'Top',
      side: 'Side',
      photoPlaceholder: 'Inspection photo',
      empty: 'No shots to display',
      prev: 'Prev',
      next: 'Next',
    },
    visionInspection: {
      kpi: {
        inspected: 'Inspected',
        ok: 'Good',
        ng: 'Defect',
        ngRate: 'Defect rate',
        uninspected: 'Not inspected',
      },
      typeDistribution: 'Defects by type',
      ngTotal: '{n} defects',
      typeFilterHint: 'Click to show only this type',
      types: {
        FLASH: 'Flash',
        WELDLINE: 'Weld line',
        SHORT: 'Short shot',
        SINK: 'Sink mark',
        UNKNOWN: 'Other',
      },
      date: 'Date',
      verdict: 'Result',
      defectType: 'Type',
      verdicts: {
        all: 'All',
        ok: 'Good',
        ng: 'Defect',
      },
      resultCount: '{n} results',
      empty: 'No vision inspection results for this date',
      emptyFiltered: 'No results match the filter',
      noImage: 'No image',
      detailTitle: 'Vision inspection · Shot #{n}',
      close: 'Close',
      unjudged: 'Unjudged',
      field: {
        verdict: 'Vision result',
        defectType: 'Defect type',
        shotTime: 'Shot time',
        mold: 'Mold',
        processResult: 'Process inspection',
        imageFile: 'Image file',
        shotUuid: 'Shot UUID',
        sync: 'Shot sync',
      },
      processNote: 'The process inspection result is the process AI judgment for the same shot, shown for reference. See Fusion Inspection for the combined final judgment.',
      prev: 'Prev',
      next: 'Next',
    },
    shotSync: {
      source: { label: 'Data source', processDemo: 'Process: demo', processReal: 'Process: collected', imageDemo: 'Image: demo camera', imageReal: 'Image: IV4 real', verdictDemo: 'Verdict: demo', liveLast: 'Site IV4 last received {t} ({ago})', liveNone: 'No site IV4 images received', liveHint: 'Site IV4 images are still collected in demo-camera mode. Switch to IV4 mode once reception is steady' },
      ago: { min: '{n} min ago', hour: '{n} h ago' },
      engine: { on: 'Sync engine running', off: 'Sync engine off', lastRun: 'Last run {t}' },
      mode: { TIME_WINDOW: 'Time window', SEQUENCE: 'Sequence' },
      kpi: { images: 'Settled images', pairRate: 'Paired', confidence: 'Avg confidence', unmatched: 'Unmatched', clock: 'Camera clock offset', lag: 'Shot→capture lag' },
      kpiHint: { clock: 'How far the camera clock lags the server. Estimated every run and applied to image times', lag: 'Time from injection to capture. Updated only when the evidence is strong' },
      unit: { sec: '{v}s' },
      timeline: { title: 'Live sync (last 3 min)', sub: 'Lag L {lag}s · tolerance ±{tol}s', shots: 'Shots', images: 'Images', pending: 'Settling', empty: 'No data in the last 3 minutes', off: 'Station is off, live sync is paused' },
      legend: { shot: 'Paired shot', shotEmpty: 'Shot without image', match: 'Match', check: 'Check', none: 'Unmatched', pending: 'Settling', window: 'Window (shot + L ± τ)' },
      trend: { title: '10-min trend (last 3 h)', sub: 'Settled images by status', empty: 'No trend data', lagRange: 'Lag L {v}s', clockRange: 'Clock offset {v}s' },
      date: 'Date', status: 'Status',
      filters: { all: 'All', match: 'Match', check: 'Check', unmatched: 'Unmatched' },
      statuses: { MATCH: 'Match', CHECK: 'Check', MISMATCH: 'Mismatch', IMAGE_ONLY: 'Image only', SHOT_ONLY: 'Shot only', PENDING: 'Settling' },
      reasonsLabel: 'Unmatched reasons:',
      reasons: { DUPLICATE: 'Duplicate capture', OUT_OF_WINDOW: 'Outside window', NO_SHOT: 'Machine stopped', SHOT_TAKEN: 'Shot already paired', LOW_CONFIDENCE: 'Low confidence', NO_IMAGE: 'Missed capture' },
      resultCount: '{n} items',
      empty: 'No results for the selected filters',
      col: { status: 'Status', shot: 'Shot', shotTime: 'Shot time', image: 'Image', captured: 'Camera time → corrected', residual: 'Residual', confidence: 'Confidence', verdict: 'Verdict' },
      verdicts: { ok: 'OK', ng: 'NG' },
      demoTag: 'Demo',
      prev: 'Prev', next: 'Next', close: 'Close',
      note: 'Residual = corrected capture time − (shot time + lag L); closer to 0 is better. Only Match/Check pairs feed Vision and Fusion Inspection; unmatched images are kept with a reason.',
      detail: { titleShot: 'Shot #{n} sync detail', titleImage: 'Unmatched image', reason: 'Reason', captured: 'Camera time (file name)', saved: 'Vision PC saved time', note: 'The IV4 camera clock runs about 3 minutes behind the server. The engine corrects it from the gap between the vision PC saved time and the file-name time before pairing.' },
      noStation: { title: 'No vision camera station on this machine', desc: 'After a camera is installed and a sync station is registered, the engine pairs shots and images automatically and links them to Vision and Fusion Inspection.', shots: '{n} shots today' },
      sourceNote: 'Data source — {items}',
      sourceItems: { process: 'demo process', camera: 'demo camera images', verdict: 'demo verdicts' },
    },
    fusionInspection: {
      formulaTitle: 'Fusion rule',
      formulaRule: 'α + β = 1, defect if S_fusion ≥ θ',
      legendVision: 'S_vision · vision defect probability (0–1)',
      legendProcess: 'S_process · process anomaly score (0–1)',
      legendWeights: 'α·β·θ · weights per defect type (table)',
      weightsTitle: 'Weights by defect type',
      planWeights: 'initial values',
      planWeightsNote: 'Current weights are the initial values from the project plan. Once 200+ verified defect labels exist, α is searched per type in 0.05 steps and replaced with the value that gives the best F1.',
      noWeights: 'No weight information',
      colType: 'Type',
      colSplit: 'Vision : Process',
      vision: 'Vision',
      process: 'Process',
      fusion: 'Fusion',
      kpi: {
        decided: 'Fused shots',
        processRate: 'Process defect rate',
        visionRate: 'Vision defect rate',
        fusionRate: 'Final defect rate',
        rescued: 'Ambiguous caught',
        suppressed: 'Process-only cleared',
      },
      kpiHint: {
        rescued: 'Vision alone said good, but a process anomaly made fusion call it a defect (click to filter)',
        suppressed: 'Only the process was abnormal and the image was clean, so fusion called it good (click to filter)',
      },
      countN: '{n}',
      matrixTitle: 'Process × Vision agreement',
      matrixSub: 'Click a cell to filter the list',
      visionOk: 'Vision good',
      visionNg: 'Vision defect',
      processOk: 'Process good',
      processNg: 'Process defect',
      fusedNg: 'fused defect {n}',
      finalTypeTitle: 'Fused defect types',
      processTypeNote: 'Process-caused = no visible type in the image, but fusion judged a defect because of a process anomaly',
      date: 'Date',
      finalVerdict: 'Final',
      all: 'All',
      ok: 'Good',
      ng: 'Defect',
      caseLabel: 'Case',
      cases: {
        all: 'All',
        disagree: 'Disagreement',
        changed: 'Changed by fusion',
        rescued: 'Ambiguous caught',
        suppressed: 'Process-only cleared',
      },
      cells: {
        POK_VOK: 'Process good · Vision good',
        POK_VNG: 'Process good · Vision defect',
        PNG_VOK: 'Process defect · Vision good',
        PNG_VNG: 'Process defect · Vision defect',
      },
      empty: 'No fusion results for this date. Only shots with both process and vision results are judged.',
      emptyFiltered: 'No results match the filter',
      colTime: 'Time',
      colShot: 'Shot',
      colWeight: 'α / β',
      colFusion: 'Fusion score (│=θ)',
      colCase: 'Case',
      decisionCase: {
        BOTH_NG: 'Both defect',
        BOTH_OK: 'Both good',
        BOTH_OK_FUSED_NG: 'Both good → defect',
        VISION_ONLY_NG_FUSED_NG: 'Vision only → defect',
        VISION_ONLY_NG_FUSED_OK: 'Vision only → good',
        PROCESS_ONLY_NG_FUSED_NG: 'Process only → defect',
        PROCESS_ONLY_NG_FUSED_OK: 'Process only → good',
        NONE: '—',
      },
      verdictScoreNote: '{n} shots have no vision model score, so the score was taken from the vision verdict (defect 0.85, good 0.10).',
      detailTitle: 'Fusion judgment · Shot #{n}',
      close: 'Close',
      noImage: 'No image',
      calcTitle: 'Calculation',
      appliedWeight: 'Weights applied: {type}',
      margin: 'Margin',
      decisionCaseLabel: 'Case',
      finalType: 'Final defect type',
      shotTime: 'Shot time',
      mold: 'Mold',
      scoreSource: 'Vision score source',
      source: {
        model: 'Vision model probability',
        verdict: 'Derived from vision verdict',
      },
      weightVersion: 'Weight version',
      types: {
        FLASH: 'Flash',
        WELDLINE: 'Weld line',
        SHORT: 'Short shot',
        SINK: 'Sink mark',
        PROCESS: 'Process-caused',
        DEFAULT: 'Default (unknown type)',
      },
      prev: 'Prev',
      next: 'Next',
    },
    shotJudge: {
      injectionInfo: 'Injection Info',
      drawingCaption: 'Product drawing · {id}',
      noImage: 'No drawing image',
      productNumber: 'Product No.',
      productName: 'Product',
      settingsTitle: 'Set values',
      settingsBadge: 'Reference · read-only',
      settingsNote: 'Set values in blue · source is Process tab > Set values (single source)',
      settingsEstimatedNote: 'Cushion has no set value, so the last 10-shot average (estimated) is used',
      estimated: 'est.',
      shotHistory: 'Shot History',
      recentN: 'Last {n} shots',
      defectOnly: 'Defects only',
      colShot: 'Shot',
      colMetering: 'Meter',
      colInjection: 'Inj.',
      colHeater: 'Heater',
      colSpeed: 'Speed',
      colCushion: 'Cushion',
      colTime: 'Time',
      colJudge: 'Result',
      good: 'Good',
      bad: 'Defect',
      warn: 'Warning',
      none: 'Unjudged',
      tableNote: 'Only out-of-spec cells are red — rows are not filled · click a row to refresh the comparison chart · out-of-spec = mean ±3σ of loaded shots (estimated)',
      loading: 'Loading shot history...',
      loadFailed: 'Failed to load shot history',
      empty: 'No shots to display',
      compareTitle: 'Set vs Measured',
      shotBadge: 'Shot #{n} · {j}',
      settingLegend: 'Set',
      measuredLegend: 'Measured',
      axisMetering: 'Metering pos.',
      axisInjection: 'Injection pos.',
      axisHeater: 'Heater temp.',
      axisSpeed: 'Injection speed',
      axisCushion: 'Cushion',
      axisTime: 'Injection time',
      outOfSpec: '{axes} out of spec',
      inSpec: 'All axes within spec',
      noSelection: 'Select a shot from the history',
      lstmButton: 'LSTM defect cause analysis',
      measuredTitle: 'Measured values — #{n}',
      judgeLabel: 'Result',
      mMetering: 'Metering pos.',
      mInjection: 'Injection pos.',
      mHeater: 'Heater temp.',
      mSpeed: 'Inj. speed',
      mCushion: 'Cushion',
      mTime: 'Inj. time',
      lstmTitle: 'LSTM Defect Cause Analysis - Inline (Top 3)',
      lstmImportance: '1. Defect factor importance',
      lstmDominant: 'This defect is dominated by {f} ({p}%)',
      lstmRecommend: '2. Process tuning recommendations',
      lstmDetail: 'View full AI analysis',
      colParam: 'Parameter',
      colCurrent: 'Current',
      colRecommended: 'Recommended',
      lstmConfidence: '3. Model prediction confidence',
      confidence: 'Confidence',
      confidenceNote: 'How much this analysis can be trusted - {p}% ({lv})',
      levelHigh: 'high',
      levelMid: 'medium',
      levelLow: 'low',
      lstmLoading: 'Loading LSTM analysis...',
      lstmFailed: 'Failed to load LSTM analysis (AI service not responding)',
      lstmNoCraft: 'No product ID, so LSTM analysis cannot run',
      lstmNoData: 'No analysis data',
      close: 'Close',
    },
    production: {
      trendTitle: 'Production Trend (last 14 days)',
      avgLine: '14-day avg',
      trendNote: 'No per-machine target, so the average of days with production (estimated) is the baseline · numbers above bars are the difference from the average · production = shots',
      sampleNote: 'Daily aggregation API not deployed — last {n} shots grouped by date (estimated) · baseline is the average of days with production',
      todayTitle: 'Today',
      qualityTitle: 'Good / Defect',
      production: 'Production',
      targetRatio: 'vs Target',
      pph: 'PPH',
      utilization: 'Utilization',
      goodRate: 'Good rate',
      defect: 'Defects',
      unitShot: 'shot',
      unitShotPerHour: 'shot/h',
      estimated: 'est.',
      noTarget: 'No daily target is set for this machine',
      loading: 'Loading production data...',
      loadFailed: 'Failed to load production data',
      empty: 'No shot history in the last 14 days',
      kpiNote: 'Production, good rate and defects are from today shot history (good rate over judged shots) · PPH is the average of hours with production (estimated) · utilization comes from the machine card 24h timeline · vs Target is — because no per-machine target exists',
    },
    overviewNew: {
      realtime: 'Live Operation',
      estimated: 'est.',
      estimateHint: 'No stage signal from the backend; the stage is estimated from the last shot time and setpoint durations',
      statusRunning: 'Running',
      statusIdle: 'Idle',
      statusStopped: 'Stopped',
      injectionShort: 'Inj',
      modelLabel: 'Injection machine motion model: close, inject, hold, cool, open',
      modelLoading: 'Loading model...',
      currentValues: 'Current Values',
      injSpeed: 'Inj. Speed',
      injPressure: 'Inj. Pressure',
      screwPosition: 'Screw Position',
      injTime: 'Inj. Time',
      nozzleTemp: 'Nozzle Temp',
      barrelTemp: 'Barrel Temp',
      cctv: 'CCTV Live',
      cctvPlaceholder: 'Camera Live',
      cctvNotConnected: 'Camera not connected',
      kpiUtilization: 'Utilization',
      kpiShotCount: 'Shot Count',
      kpiDefectRate: 'Defect Rate',
      kpiCycleTime: 'Cycle Time',
      tempSummary: 'Temperature Summary',
      tempLink: 'Process - Summary',
      avgTemp: 'Avg Temp',
      maxDeviation: 'Max Deviation',
      warningZones: 'Warning Zones',
      oilTemp: 'Oil Temp',
      normal: 'Normal',
      warning: 'Warning',
      zoneUnit: '',
      recentAlarms: 'Recent Alarms',
      allAlarms: 'All',
      noAlarms: 'No recent alarms',
      qualitySummary: 'Quality · Production',
      qualityLink: 'Quality · Production',
      goodRate: 'Good Rate',
      good: 'Good',
      defect: 'Defect',
      unjudged: 'Unjudged',
      cpk: 'Cpk',
      kpiDailyProduction: 'Daily Production',
      dailyProduction: 'Daily production',
      dailyUnavailable: 'Today summary API did not respond',
      loading: 'Loading data...',
      loadFailed: 'Failed to load data.',
    },
    dataLog: {
      subTab: { shots: 'Shot log', drive: 'Drive history', alarms: 'Alarm history', analysis: 'Alarm analysis' },
      filter: 'Filter',
      reset: 'Reset',
      unitNote: 'Units: time in s, position and cushion in mm (hover a column header)',
      factory: 'Factory',
      machine: 'Machine',
      product: 'Product (mold)',
      period: 'Period',
      shotRange: 'Shot range',
      columnsPick: 'Columns',
      severityNotInDrive: 'Drive history has no severity information',
      limit: 'Rows',
      limitOption: '{n} rows',
      startShot: 'Shot range (from no.)',
      startShotPlaceholder: 'All',
      sampleInterval: 'Sample interval',
      intervalOption: 'Every {n} shots',
      columns: 'Columns',
      shotsTitle: 'Shot log',
      totalCount: '{n} rows',
      outCount: '{n} out of range',
      estimated: 'est.',
      onlyOut: 'Out of range only',
      no: 'No.',
      shotTime: 'Shot time',
      outNote: 'Out of range = beyond mean ±{k}σ of the loaded shots per column (no limits are configured, estimated on screen)',
      driveTitle: 'Drive unit history',
      driveType: 'Drive unit',
      time: 'Time',
      action: 'Action',
      pressure: 'Pressure',
      speed: 'Speed',
      position: 'Position',
      searchPlaceholder: 'Search...',
      all: 'All',
      alarmsTitle: 'Alarm history',
      severity: 'Severity',
      critical: 'Critical',
      warning: 'Warning',
      info: 'Info',
      occurredAt: 'Occurred at',
      code: 'Code',
      message: 'Message',
      settingValue: 'Setting',
      actualValue: 'Actual',
      status: 'Status',
      statusActive: 'Active',
      statusResolved: 'Resolved',
      paretoTitle: 'Alarm Pareto analysis',
      paretoNote: 'Count by code + cumulative ratio',
      errorCode: 'Error',
      timelineTitle: 'Alarm timeline',
      timelineNote: 'Count by time',
      baseline80: '80% line',
      count: 'Count',
      cumulative: 'Cumulative',
      loading: 'Loading data...',
      loadFailed: 'Failed to load data.',
      noData: 'No data',
    },
    spcNew: {
      monitoring: '{p} monitoring',
      parameter: 'Parameter',
      loading: 'Loading SPC data...',
      spcUnavailable: 'No SPC configuration for this machine and parameter, so the control chart cannot be calculated',
      noChart: 'Not enough shots to draw the control chart',
      chartNote: 'Subgroup mean (X̄) chart · time is the latest shot of each subgroup',
      rChartNote: 'Subgroup range (max − min) chart · same subgroups as the X̄ chart',
      moldTempNoData: 'Mold temperature is not collected, so its control chart cannot be calculated',
      noData: 'no data',
      pp: 'PP',
      ppk: 'PPK',
      anomalyCount: 'Latest {n}',
      outOfControl: 'Out',
      capabilityTitle: 'Process capability',
      cp: 'CP',
      cpk: 'CPK',
      defectRate: 'Nonconformance rate',
      subgroupSize: 'Subgroup size',
      productionTitle: 'Production summary',
      production: 'Production',
      goodRate: 'Good rate',
      pph: 'PPH',
      defects: 'Defects',
      estimated: 'est.',
      unitShot: 'shot',
      unitShotPerHour: 'shot/h',
      productionNote: 'Based on shot history of {d} · good rate uses judged shots (good + bad) · PPH is the average of hours with production (estimated)',
      loadFailed: 'Failed to load data.',
    },
    processNew: {
      subTab: { cycle: 'Cycle', temperature: 'Temperature', drive: 'Drive', monitor: 'Monitor', setup: 'Settings' },
      autoScale: 'Auto scale',
      dataHold: 'Data hold',
      chart: 'Chart',
      chartAll: 'All',
      loading: 'Loading data...',
      loadFailed: 'Failed to load data.',
      noData: 'No data',
      noProfile: 'No profile data',
      noTrend: 'No trend data',
      estimated: 'est.',
      step: 'Step',
      shotNo: 'Shot',
      average: 'Avg',
      overlay: '{a}/{b} overlay',
      singleShot: 'Shot {a}',
      injectionProfile: 'Injection Profile',
      cycleTrend: 'Cycle Time Trend',
      holdingProfile: 'Holding Profile',
      meteringProfile: 'Metering Profile',
      cycleStats: 'Cycle Statistics',
      statAvg: 'Avg cycle',
      statMin: 'Min',
      statMax: 'Max',
      statStd: 'Std dev',
      statLatest: 'Latest',
      legendSpeed: 'Speed',
      legendPressure: 'Pressure',
      legendShot: 'SHOT',
      legendMetering: 'Metering',
      legendCooling: 'Cooling',
      legendHolding: 'Holding',
      legendInjection: 'Injection',
      legendCycle: 'Cycle',
      legendHoldingPressure: 'Holding',
      legendTime: 'Time',
      legendBackPressure: 'Back pressure',
      legendCushion: 'Cushion',
      legendMeteringPressure: 'Metering P.',
      legendInjectionPressure: 'Injection P.',
      legendUpper: 'Upper',
      legendLower: 'Lower',
      statusNormal: 'Normal',
      statusError: 'Error',
      statusRunning: 'Normal',
      statusIdle: 'Idle',
      statusStopped: 'Stopped',
      setTemp: 'Set',
      deviation: 'Dev.',
      tempTrend: 'Temperature Trend',
      deviationStatus: 'Temperature Deviation',
      deviationTolerance: 'Deviation by zone (tolerance ±{n}℃)',
      deviationFromAvg: '± deviation from all-zone average (tolerance ±{n}℃)',
      diffFromAvg: 'vs. average',
      avgLine: 'Avg {v}℃',
      tempStats: 'Temperature Statistics',
      avgTemp: 'Avg temp',
      maxDeviation: 'Max deviation',
      maxTemp: 'Max',
      driveInjection: 'Injection Drive',
      driveMetering: 'Metering Drive',
      driveHolding: 'Holding Drive',
      pressure: 'Pressure',
      speed: 'Speed',
      position: 'Position',
      elapsed: 'Elapsed',
      pressureTrend: 'Pressure Trend',
      motorStatus: 'Motor Status',
      backPressureMonitor: 'Back Pressure Monitoring',
      axisPressureShot: 'Pressure / Shot no.',
      axisStatusShot: 'Status / Shot no.',
      axisBackPressureShot: 'Back pressure / Shot no.',
      moldEjectorSettings: 'Mold · Ejector Settings',
      moldOpenPos: 'Mold open pos.',
      moldClosePos: 'Mold close pos.',
      moldOpenTime: 'Mold open time',
      moldCloseTime: 'Mold close time',
      ejectorForward: 'Ejector forward',
      ejectorBackward: 'Ejector backward',
      watchAutoWatch: 'Auto watch',
      watchUse: 'On',
      watchNotUse: 'Off',
      watchReference: 'Reference',
      watchRefAuto: 'Auto sampling',
      watchRefUser: 'User defined',
      watchNote: 'Reference = mean of last {n} shots, limits = ±{k}σ (estimated)',
      watchLegendOut: 'Out of limits',
      watchLegendImportant: 'Key watch item',
      watchTable1: 'Watch table 1 - Drive parameters (sec/mm)',
      watchTable2: 'Watch table 2 - Injection · Holding parameters',
      watchRowGroup: 'Item',
      watchRowActual: 'Actual',
      watchRowDeviation: 'Deviation',
      watchRowReference: 'Reference',
      watchRowUpper: 'Upper',
      watchRowLower: 'Lower',
      watchRowSelect: 'Select',
      setupCount: '{n} items',
      setupHistoryButton: 'View change history',
      setupHistoryUnavailable: 'Setting change history API is not available yet',
      setupHistoryLess: 'Show latest 20 only',
      setupAddWidget: 'Add as dashboard widget',
      setupWidgetNoSlot: 'No empty slot on the dashboard',
      setupHistoryTitle: 'Recent setting changes',
      setupHistoryTime: 'Changed at',
      setupHistoryItem: 'Item',
      setupHistoryBefore: 'Before',
      setupHistoryAfter: 'After',
      setupHistoryUser: 'Changed by',
      setupHistoryEmpty: 'No recent setting changes',
    },
  },
  equipmentBoard: {
    selectMachine: 'Select Machine',
    loading: 'Loading...',
    update: 'Updated',
    empty: 'Please select a machine',
    alarmHistory: 'Alarm History',
    alarmEmpty: 'No alarm history',
    occurredPrefix: 'Occurred ',
    statusActive: 'Active',
    statusResolved: 'Resolved',
    shotData: 'Shot Data',
    shotCountSuffix: '{n}',
    noData: 'No data',
    panelAlarm: 'Alarm',
    remainingSuffix: '+{n} more',
    confirm: 'OK',
    confirmWithRemaining: 'OK (+{n} more)',
    cols: {
      shotTime: 'Shot Time',
      craftId: 'Product',
      shotCount: 'Shot Count',
      cycleTime: 'Cycle Time',
      injTime: 'Injection Time',
      holdTime: 'Holding Time',
      chargeTime: 'Charge Time',
      moldOpenTime: 'Mold Open Time',
      moldCloseTime: 'Mold Close Time',
      fetchTime: 'Fetch Time',
      ejectTime: 'Eject Time',
    },
  },
  machineDataView: {
    title: 'Machine Data',
    loading: 'Loading...',
    loadingDataInit: 'Loading data...',
    loadingProgressInit: 'Loading {total} machines...',
    loadingProgress: 'Loading {loaded}/{total} machines...',
    allMachines: 'All Machines',
    machineCount: '{n} machines',
    allMolds: 'All Molds',
    countSuffix: '{n}',
    total: 'Total {n}',
    filteredTotal: '{filtered} / {total}',
    empty: 'No data',
    pageInfo: '{start}-{end} / {total}',
  },
};

export default monitoring;
